import React from 'react';
import { Button } from '@mui/material';

// ForwardRef to support form libraries or parent ref usage
const BasicBtn = React.forwardRef(({
    children,
    name,
    type = "button",
    onClick,
    sx = {},
    variant = "contained",
    color = "white",
    smColor = "primary",
    fullWidth = true,
    ...rest
}, ref) => {
    return (
        <Button
            ref={ref}
            type={type}
            variant={variant}
            color={color}
            smColor={smColor}
            fullWidth={fullWidth}
            onClick={onClick}
            sx={{
                color: 'white.main',
                bgcolor: {
                    xs: (theme) => theme.palette[color]?.main || color,
                    sm: (theme) => theme.palette[smColor]?.main || color,
                 },
                fontSize: 13,
                textTransform: 'capitalize',
                '&:hover': {
                    bgcolor: {
                        xs: (theme) => theme.palette[color]?.main || color,
                        sm: (theme) => theme.palette[smColor]?.main || color,
                     },
                },
                py: "12px",
                boxShadow: 4,
                ...sx,
            }}
            {...rest}
        >
            {children || name || 'Submit'}
        </Button>
    );
});

export default BasicBtn;
